import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { type CreatedWorkspaceLocation, useTrackCreatedWorkspace } from '@air/analytics';
import { Workspaces } from '@air/api';

import { getWorkspacesListKey } from '~/swr-hooks/workspaces/useWorkspaces';

export const useCreateWorkspace = () => {
  const queryClient = useQueryClient();
  const { trackCreatedWorkspace } = useTrackCreatedWorkspace();

  const createWorkspace = useCallback(
    async ({
      workspaceName,
      email,
      location,
    }: {
      workspaceName: string;
      email: string;
      location: CreatedWorkspaceLocation;
    }) => {
      const workspace = await Workspaces.create({
        workspace: { name: workspaceName, status: 'active' },
      });

      await queryClient.invalidateQueries({ queryKey: getWorkspacesListKey() });

      trackCreatedWorkspace({
        ...workspace,
        creatorId: email,
        location,
      });

      return workspace;
    },
    [queryClient, trackCreatedWorkspace],
  );

  return {
    createWorkspace,
  };
};
